<template>
  <div class="content">
   <div class="container-fluid mt-3">
     <card
       class="no-border-card"
       footer-classes="pb-2"
       v-loading.fullscreen.lock="loading"
     >
       <template slot="header">
         <div class="row align-items-center">
           <div class="col-lg-6 col-md-6 col-12">
             <h2 class="mb-0">Surveys</h2>
           </div>
           <div class="col-lg-6 col-md-6 text-right">
             <base-button class="custom-btn" v-on:click="resetFilters()"
               ><i aria-hidden="true" class="fa fa-refresh"></i> Clear
               Filters</base-button
             >
             <base-button v-if="canCreate" @click.prevent="createSurvey()" class="custom-btn"
               ><i aria-hidden="true" class="fa fa-plus"></i> Add
               Survey</base-button
             >
           </div>
         </div>
       </template>
       <div>
         <div class="row  flex-wrap">
           <div class="col-md">
             <base-input
               label="Search:"
               placeholder="Search..."
               prepend-icon="fas fa-search"
               v-model="searchQuery"
             ></base-input>
           </div>
           <div class="col-md">
             <base-input label="Status:">
               <el-select
                 class="select-primary"
                 v-model="filters.status"
                 v-on:change="changePage(1)"
               >
                 <el-option
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"
                   class="select-primary"
                   v-for="item in statuses"
                 ></el-option>
               </el-select>
             </base-input>
           </div>
           <div class="col-md">
             <base-input label="Showing:">
               <el-select
                 class="select-primary pagination-select"
                 placeholder="Per page"
                 v-model="perPage"
                 v-on:change="changePage(1)"
               >
                 <el-option
                   :key="item"
                   :label="item"
                   :value="item"
                   class="select-primary"
                   v-for="item in perPageOptions"
                 ></el-option>
               </el-select>
             </base-input>
           </div>
         </div>
         <div class="user-eltable">
           <el-table
             :data="tableData"
             @selection-change="selectionChange"
             class="surveyGrid"
             header-row-class-name="thead-light"
             highlight-current-row
             id="tbl1"
             role="table"
             row-key="id"
             stripe
           >
             <el-table-column
               label="Name"
               min-width="280px"
               prop="name"
             >
             <template slot-scope="props">
                 <span
                   @click="editSurvey(props.row.id)"
                   class="text-blue linkColor comppaniescount"
                   >{{ props.row.name }}</span
                 >
               </template>
            </el-table-column>
             <el-table-column label="#Courses" prop="course">
               <template slot-scope="props">
                 <span
                   @click="getSurveyCourses(props.row.id)"
                   class="text-blue linkColor comppaniescount"
                   >{{ props.row.course_survey_count }}</span
                 >
               </template>
             </el-table-column>
             <el-table-column label="Status" prop="status">
               <template slot-scope="props">
                 <div
                   class="d-flex"
                   v-on:click="changeStatus(props.$index, props.row)"
                 >
                   <base-switch
                     class="mr-1"
                     type="success"
                     v-if="props.row.status"
                     v-model="props.row.status"
                   ></base-switch>
                   <base-switch
                     class="mr-1"
                     type="danger"
                     v-else
                     v-model="props.row.status"
                   ></base-switch>
                 </div>
               </template>
             </el-table-column>
             <el-table-column align="left" label="Actions" min-width="150px">
               <template slot-scope="{ $index, row }">
                 <div class="d-flex align-items-center display-2">
                   <el-tooltip v-if="canEdit" content="Edit" placement="top">
                     <base-button
                       @click="editSurvey(row.id)"
                       class="display-4"
                       data-original-title="Edit"
                       icon
                       size="lg"
                       type=""
                     >
                       <i class="text-default fa fa-pencil-square-o fa-lg"></i>
                     </base-button>
                   </el-tooltip>
                   <el-tooltip v-if="canDelete" content="Delete" placement="top">
                     <base-button
                       @click.native="deleteSurvey(row.id)"
                       class=""
                       data-original-title="Delete"
                       icon
                       size=""
                       type=""
                     >
                       <i class="text-danger fa fa-trash fa-lg"></i>
                     </base-button>
                   </el-tooltip>
                 </div>
               </template>
             </el-table-column>
           </el-table>
         </div>
       </div>
       <div class="d-flex justify-content-end " slot="footer">
         <nav v-if="pagination && tableData.length > 0">
           <div class="row">
             <div class="col-md-12">
               <ul
                 class="pagination custompagination  justify-content-end align-items-center"
               >
                 <p class="p-0 m-0 mr-2">
                   Showing {{ tableData.length }} of {{ totalData }} entries
                 </p>
                 <li :class="{ disabled: currentPage === 1 }" class="page-item">
                   <a
                     @click.prevent="changePage(currentPage - 1)"
                     class="page-link"
                     href="#"
                     ><i class="fa fa-caret-left "></i
                   ></a>
                 </li>
                 <li
                   :class="{ active: page == currentPage }"
                   class="page-item"
                   v-bind:key="index"
                   v-for="(page, index) in pagesNumber"
                 >
                   <a
                     @click.prevent="changePage(page)"
                     class="page-link"
                     href="javascript:void(0)"
                     >{{ page }}</a
                   >
                 </li>
                 <li
                   :class="{ disabled: currentPage === last_page }"
                   class="page-item"
                 >
                   <a
                     @click.prevent="changePage(currentPage + 1)"
                     class="page-link"
                     href="#"
                     ><i class="fa fa-caret-right "></i
                   ></a>
                 </li>
               </ul>
             </div>
           </div>
         </nav>
       </div>
     </card>
     <modal :show.sync="showSurveyCoursesModal">
       <h4 class="modal-title mb-0" slot="header" style="color:#444C57">
         Courses
       </h4>
       <div class="user-eltable">
         <el-table
           :data="surveyCourses"
           @selection-change="selectionChange"
           class="compGrid assign-cr-modal"
           header-row-class-name="thead-light"
           highlight-current-row
           id="tbl1"
           role="table"
           row-key="id"
           stripe
         >
           <el-table-column min-width="280px" prop="name">
             <template slot="header">
               <span>Name</span>
             </template>
             <template slot-scope="props">
              <a herf="#" @click.prevent="goToCourse(props.row.id)">
                 <span class="text-blue linkColor">{{ props.row.name }}</span>
              </a>
             </template>
           </el-table-column>
         </el-table>
       </div>
     </modal>
     <!-- Survey  -->
     <modal :show.sync="showSurveyCreateEditModal" class="user-modal">
          <h4 slot="header" class="modal-title mb-0">
              {{ surveyModalName }}
          </h4>
          <div class="row align-items-center">
              <div class="col-md-12 text-right">
                  <base-button class="custom-btn" @click.prevent="saveSurvey">
                      Save Survey
                  </base-button>
              </div>
              <div class="col-md-10  col-lg-11">
                  <base-input
                      v-model="survey.name"
                      label="Title *"
                      placeholder="Enter Survey test title"
                  ></base-input>
              </div>
              <!-- required switch -->
              <!-- <div class="col-md-2 col-lg-1 col-12 text-right">
                        <label>
                          <base-switch
                              class="mt-3"
                              type="success"
                              v-model="surveytest.required"
                              onText="Required"
                              offText="Not Required"
                          ></base-switch>
                      </label>
              </div> -->
              <!-- end required switch -->
              <div class="col-md-12">
                  <label class="form-control-label">Instructions *</label>
                  <vue-editor v-model="survey.instructions"></vue-editor>
              </div>
          </div>

          <div
              class="brdr question_box mt-3"
              v-for="(question, q_index) in survey.survey_questions"
              :key="question.id"
          >
              <div class="row align-items-center">
                  <div class="col-md-7">
                      <h4 style="color: #444C57;">Question {{ q_index + 1 }}</h4>
                  </div>
                  <div class="col-md-4 col-6 ">
                      <div
                          class="d-flex justify-content-md-end"
                          v-on:click="changeStatus(props.$index, props.row)"
                      >
                          <base-switch
                              class="mr-1"
                              v-if="question.question_status"
                              type="success"
                              :id="'testQuestion-switch_' + q_index"
                              v-model="question.question_status"
                          ></base-switch>
                          <base-switch
                              class="mr-1"
                              v-else
                              type="danger"
                              v-model="question.question_status"
                              :id="'testQuestion-switch_' + q_index"
                          ></base-switch>
                      </div>
                  </div>
                  <div class="col-md-1 col-6 ">
                      <base-button
                          type="danger"
                          style="float:right;"
                          size="sm"
                          @click.prevent="removeQuestion(q_index)"
                      >
                          <i class="fa fa-trash"></i>
                      </base-button>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12 pt-2 pb-4">
      <textarea
          class="form-control"
          type="text"
          placeholder="Question"
          v-model="question.question"
      >
      </textarea>
                      <span
                          class="text-danger small"
                          v-if="
          isRequired &&
            surveytest_save_clicked &&
            question.question === '' &&
            question.question_status
        "
                      >Question Field is Required!</span
                      >
                  </div>

                  <div class="col-md-4">
                      <label class="form-control-label">Answer Type: </label>
                      <el-select
                          class="w-100"
                          v-model="question.answer_type"
                          placeholder="Select Answer Type"
                      >
                          <el-option
                              v-for="option in answer_type"
                              class="select-primary"
                              :value="option.value"
                              :label="option.label"
                              :key="option.value"
                          >
                          </el-option>
                      </el-select>
                  </div>
              </div>
              <div class="row mt-2 mb-2" v-if="question.answer_type == 1">
                  <div class="col-md-4">
                      <div class="row">
                          <div class="col-md-12">
                              <label class="form-control-label">Select Validation </label>
                          </div>
                          <div class="col-md-12">
                              <el-select
                                  v-model="question.checked_validations"
                                  class="w-100"
                              >
                                  <el-option
                                      v-for="text in validationtype"
                                      :key="text.value"
                                      :value="text.value"
                                      :label="text.label"
                                  ></el-option>
                              </el-select>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <label class="form-control-label">Preview </label>
                      <base-input
                          v-model="previewPhone"
                          v-if="question.checked_validations == 1"
                          placeholder="(555) 555-5555"
                          @input="acceptNumber"
                      ></base-input>
                      <base-input
                          type="email"
                          name="Email"
                          v-model="previewEmail"
                          v-if="question.checked_validations == 2"
                          placeholder="Enter valid email"
                      ></base-input>
                      <base-input
                          v-model="previewText"
                          v-if="question.checked_validations == 3"
                          placeholder="Enter Text"
                      ></base-input>
                      <el-date-picker
                          v-model="previewDate"
                          v-if="question.checked_validations == 4"
                          style="width: 100%"
                          type="date"
                          placeholder="Pick a day"
                          format="MM/dd/yyyy"
                          :picker-options="pickerOptions1"
                      >
                      </el-date-picker>
                      <base-input
                          v-model="previewSsn"
                          v-if="question.checked_validations == 5"
                          placeholder="Enter SSN"
                      ></base-input>
                  </div>
              </div>

              <div class="row " v-if="question.answer_type == 2">
                  <div class="col-md-12">
                      <div class="row">
                          <div class="col-md-8">
                              <div class="row ">
                                  <div class="col-sm-9 col-12">
                                    <div class="currest-ans-label">
                                      <label class="form-control-label">Correct Answer</label>
                                    </div>
                                  </div>

                              </div>
                              <div
                                  class="row"
                                  v-for="(option, o_index) in question.answers"
                                  :key="option.id"
                              >
                                  <div class="col-sm-6 col-7 mt-2">
                                      <base-input
                                          type="text"
                                          :label="'Answer Option ' + (o_index + 1)"
                                          placeholder="Option"
                                          v-model="option.answer"
                                      >
                                      </base-input>
                                      <span
                                          class="text-danger small"
                                          v-if="
                  isRequired &&
                    surveytest_save_clicked &&
                    option.answer === '' &&
                    question.question_status
                "
                                >Option Field is Required!</span
                                >
                              </div>
                              <div class="col-sm-4  col-5">
                                <div class="que-ans-row">
                                  <div>
                                    <base-checkbox
                                      label="Correct Answer"
                                      class="pull-right"
                                      v-model="option.correct_answer"
                                    ></base-checkbox>
                                  </div>
                                  <div>
                                    <base-button
                                      size="sm"
                                      type="danger"
                                      @click.prevent="
                  removeQuesionOption(q_index, o_index)
                "
                                    >
                                      <i class="fa fa-trash"></i>
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                              <div class="row">
                                  <div class="col-md-7">
                                      <label
                                          style="color: #444C57;"
                                          class=" cursor"
                                          v-on:click="addQuestionOption(q_index)"
                                      ><b class="mr-1">+</b>Add Another Option</label
                                      >
                                  </div>
                                  <div class="col-md-5 text-center"></div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row mt-2">
              <div class="col-md-12">
                  <label
                      class=" cursor"
                      style="color: #444C57;"
                      v-on:click="addQuestion()"
                  ><b>+</b>Add Another Question</label
                  >
              </div>
          </div>
          <div class="text-right">
              <base-button class="custom-btn" @click.prevent="saveSurvey">
                  Save Survey Test
              </base-button>
          </div>
      </modal>
   </div>
   </div>
 </template>

<script>
import {DatePicker, Option, Select, Table, TableColumn } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import "sweetalert2/src/sweetalert2.scss";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {VueEditor, Quill} from "vue2-editor";

let timeout = null;
export default {
  name: "surveys",
  mixins: [serverSidePaginationMixin],
  components: {
    VueEditor,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,

  },
  data() {
    return {
      loading: false,
      courses: [
        {
          label: "All Courses",
          value: 0
        }
      ],
      statuses: [
        {
          label: "All Status",
          value: -1
        },
        {
          label: "Active",
          value: 1
        },
        {
          label: "Inactive",
          value: 0
        }
      ],
      survey: {
        name: "",
        id: 0,
        instructions: "",
        no_of_questions: "",
        type: "course",
        survey_questions: [
          {
              question: "",
              answer_type: "",
              question_status: true,
              checked_validations: "",
              answers: [
                  {
                      answer: "",
                      correct_answer: false
                  }
              ]
          }
        ]
      },
      answer_type: [
          {
              label: "Text",
              value: 1
          },
          {
              label: "Option",
              value: 2
          }
      ],
      validationtype: [
          {
              label: "Please Select validation",
              value: 0
          },
          {
              label: "Phone number",
              value: 1
          },
          {
              label: "Email",
              value: 2
          },
          {
              label: "Text",
              value: 3
          },
          {
              label: "Date",
              value: 4
          },
          {
              label: "SSN",
              value: 5
          }
      ],
      previewPhone: "",
      previewEmail: "",
      previewText: "",
      previewSsn: "",
      previewDate: "",
      searchQuery: "",
      pickerOptions1: {
          shortcuts: [
              {
                  text: "Today",
                  onClick(picker) {
                      picker.$emit("pick", new Date());
                  }
              },
              {
                  text: "Yesterday",
                  onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24);
                      picker.$emit("pick", date);
                  }
              },
              {
                  text: "A week ago",
                  onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit("pick", date);
                  }
              }
          ]
      },
      survey_save_clicked: false,
      isRequired: true,
      filters: {
        courses: 0,
        status: 1
      },
      tableData: [],
       canCreate:true,
      canEdit:true,
      canDelete:true,
      surveyCourses: null,
      showSurveyCoursesModal: false,
      showSurveyCreateEditModal: false,
      surveyModalName: "Add New Survey",
    };
  },
  watch: {
    searchQuery: function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    }
  },
  created: function() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    }else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
       this.getRightsDetails();
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
    }
    this.setDefaultFilterData();
  },
  methods: {
    getRightsDetails(){
       let type="Survey";
       this.$http.get("subadmin/subadmin_rights/" + type).then(resp => {
        this.canCreate=resp.data[0].permissions.indexOf("c") !== -1 ? true : false;
        this.canEdit=resp.data[0].permissions.indexOf("e") !== -1 ? true : false;
        this.canDelete=resp.data[0].permissions.indexOf("d") !== -1 ? true : false;
       });
    },
    selectionChange(selectedRowss) {
      this.selectedRows = [];
      for (let selectedRow of selectedRowss) {
        if (this.selectedRows.includes(selectedRow.id)) {
          this.selectedRows.splice(
            this.selectedRows.indexOf(selectedRow.id),
            1
          );
        } else {
          this.selectedRows.push(selectedRow.id);
        }
      }
    },
    validUrl(url) {
      var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (pattern.test(url)) {
        return true;
      }
      this.resource.url = "";
      alert("Url is not valid!");
      return false;
    },
    fetchData() {
      /**Get all the available courses*/
      if (this.courses.length == 1) {
        this.$http.post("/course/all_courses").then(response => {
          const courses = this.courses;
          response.data.courses.map(function(course) {
            courses.push({
              label: course.name,
              value: course.id
            });
          });
          this.courses = courses;
        });
      }

      const requestParameters = {
        search: this.searchQuery,
        page: this.currentPage,
        column: this.sortedColumn,
        order: this.order,
        per_page: this.perPage,
        status: this.filters.status
      };
      this.loading = true;
      
      // fetch surveys
      this.$http.get("surveys/",{params:requestParameters})
        .then(response => {
        let tableData = this.tableData;
        this.totalData = response.data.total;
        tableData = response.data.surveys;
        this.tableData = tableData;        
    }).finally(() => (this.loading = false));
      this.saveSearchData();
    },
    deleteSurvey(id) {
      console.log("id", id);
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            this.$http.delete("surveys/delete/" + id).then(resp => {
              this.fetchData();
              Swal.fire({
                title: "Deleted!",
                text: "Survey has been deleted.",
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              }).then(function() {});
            });
          }
        })
        .catch(function() {});
    },
    resetFilters() {
      this.filters.courses = 0;
      this.searchQuery = "";
      this.filters.status = 1;
      this.fetchData();
    },
    saveSearchData() {
      localStorage.setItem(
        "surveys-filters",
        JSON.stringify({
          role: "super-admin",
          search: this.searchQuery,
          courses: this.filters.courses,
          status: this.filters.status,
          page: this.currentPage,
          per_page: this.perPage
        })
      );
    },
    setDefaultFilterData() {
      let previousStateData = JSON.parse(
        localStorage.getItem("surveys-filters")
      );
      if (previousStateData !== null) {
        this.searchQuery =
          previousStateData.search != undefined
            ? previousStateData.search
            : this.searchQuery;
        this.filters.courses =
          previousStateData.courses != undefined
            ? previousStateData.courses
            : this.filters.courses;
        this.filters.status =
          previousStateData.status != undefined
            ? previousStateData.status
            : this.filters.status;
        this.perPage =
          previousStateData.per_page != undefined
            ? previousStateData.per_page
            : this.perPage;
      }
      this.fetchData();
    },
    newSurvey() {
      this.survey ={
        name: "",
        id: 0,
        instructions: "",
        no_of_questions: "",
        type: "course",
        survey_questions: [
          {
              question: "",
              answer_type: "",
              question_status: true,
              checked_validations: "",
              answers: [
                  {
                      answer: "",
                      correct_answer: false
                  }
              ]
          }
        ]
      };
      this.surveyModalName = "Add New Survey";
    },
    createSurvey(){
      this.newSurvey();
      this.showSurveyCreateEditModal = true;
    },
    addQuestion() {
      this.survey.survey_questions.push({
          question: "",
          question_status: true,
          answer_type: "",
          checked_validations: "",
          answers: [
              {
                  answer: "",
                  correct_answer: false
              }
          ]
      });
    },
    removeQuestion(index) {
        this.survey.survey_questions.splice(index, 1);
    },
    addQuestionOption(question_index) {
        this.survey.survey_questions[question_index].answers.push({
            answer: "",
            correct_answer: false
        });
    },
    removeQuesionOption(q_index, opt_index) {
        this.survey.survey_questions[q_index].answers.splice(
            opt_index,
            1
        );
    },
    saveSurvey(){
      this.survey_save_clicked = true;
      this.isRequired = true;
      if (this.survey.name !== "" && this.survey.instructions !== "") {
          for (let question of this.survey.survey_questions) {
              let correct_answer = false;
              if (question.question_status && question.answer_type == "2") {
                  this.isRequired = true;
              } else {
                  this.isRequired = false;
              }
              if (this.isRequired) {
                  if (question.question !== "") {
                      for (let answer of question.answers) {
                          if (answer.answer === "") {
                              return Swal.fire({
                                  title: "Error!",
                                  text: `All options's fields are required!`,
                                  icon: "error"
                              });
                          }
                      }
                  } else {
                      return Swal.fire({
                          title: "Error!",
                          text: `All Questions's fields are required!`,
                          icon: "error"
                      });
                  }
              }
          }
      } else {
          return Swal.fire({
              title: "Error!",
              text: `All Test's Fields are required!`,
              icon: "error"
          });
      }

      if (this.survey.id == 0) {
        this.$http
          .post("surveys/createSurvey", this.survey, this.config)
          .then(resp => {
              this.survey_question = false;
              this.fetchData();
              this.main_test = true;
              this.showSurveyCreateEditModal = false;
              this.survey_save_clicked = false;
              Swal.fire({
                  title: "Success!",
                  html:
                      "Survey added successfully.",
                  icon: "success"
              });
          })
          .catch(function (error) {
              if (error.response.status === 422) {
                  Swal.fire({
                      title: "Error!",
                      text: error.response.data.message,
                      icon: "error"
                  });
              } else {
                  Swal.fire({
                      title: "Error!",
                      text: "Something went wrong.",
                      icon: "error"
                  });
              }
          });
      }else{
        this.$http
          .put("surveys/editSurvey/" + this.survey.id, this.survey, this.config)
          .then(resp => {
              this.survey_question = false;
              this.fetchData();
              this.main_test = true;
              this.showSurveyCreateEditModal = false;
              this.survey_save_clicked = false;
              Swal.fire({
                  title: "Success!",
                  html:
                      "Survey added successfully.",
                  icon: "success"
              });
          })
          .catch(function (error) {
              if (error.response.status === 422) {
                  Swal.fire({
                      title: "Error!",
                      text: error.response.data.message,
                      icon: "error"
                  });
              } else {
                  Swal.fire({
                      title: "Error!",
                      text: "Something went wrong.",
                      icon: "error"
                  });
              }
          });
      }
      
    },

    getSurveyCourses: function(surveyId) {
      this.$http
        .get("/surveys/" + surveyId + "/courses")
        .then(response => {
          this.surveyCourses = response.data.surveyCourses;          
          this.showSurveyCoursesModal = true;
        })
        .finally(() => (this.loading = false));
    },
    editSurvey(surveyId) {
      this.loading = true;

      this.$http
          .get("surveys/edit/" + surveyId, this.config)
          .then(resp => {
            console.log(resp.data.survey[0]);
            let survey = resp.data.survey[0];
            this.updating = true;            

            // for (let surveytest of surveytests) 
                let surveytest_obj = {
                    id: survey.id,
                    name: survey.name,
                    required: survey.required,
                    instructions: survey.instruction,
                    survey_questions: []
                };
                for (let question of survey.questions) {
                    let question_obj = {
                        id: question.id,
                        question: question.question,
                        answer_type: question.question_type,
                        checked_validations: question.validation,
                        question_status: "",
                        answers: []
                    };
                    if (question.status === 1) {
                        question_obj.question_status = true;
                    } else if (question.status === 0) {
                        question_obj.question_status = false;
                    }

                    for (let answer of question.answers) {
                        let option_obj = {
                            id: answer.id,
                            answer: answer.answer
                        };
                        question_obj.answers.push(option_obj);
                    }

                    surveytest_obj.survey_questions.push(question_obj);
                }

            this.survey = surveytest_obj;
            this.surveyModalName = "Edit survey";
            this.showSurveyCreateEditModal = true;
            this.loading = false;
          })
          .catch(function (error) {
            this.loading = false;
              if (error.response.status === 422) {
                  Swal.fire({
                      title: "Error!",
                      text: error.response.data.message,
                      icon: "error"
                  });
              } else {
                  Swal.fire({
                      title: "Error!",
                      text: "Something went wrong.",
                      icon: "error"
                  });
              }
          });
        
    },
    changeStatus(index, row) {
      let prev_val = row.status;
      let status = "";
      if (prev_val) {
        status = 0;
      } else {
        status = 1;
      }
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change status!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            this.$http
              .put(
                "/surveys/update-status/" + row.id,
                {
                  status: status
                },
                self.config
              )
              .then(resp => {
                this.fetchData();
                Swal.fire({
                  title: "Success!",
                  text: "Status has been Changed.",
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
                self.tableData[index].status = !prev_val;
              });
          } else {
            self.tableData[index].status = prev_val;
          }
        })
        .catch(function() {
          self.tableData[index].status = prev_val;
        });
    },
    goToCourse(courseId){
      this.showSurveyCoursesModal = false;
      setTimeout(() => {
        this.$router.push('/edit_course?id=' + courseId);
      },300);
    }
  }
};
</script>

<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .surveyGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "Resource Name";
  }
  .surveyGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "# Courses";
  }
  .surveyGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Type";
  }
  .surveyGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Available after completion";
  }
  .surveyGrid >>> table.el-table__body td:nth-of-type(5):before {
    content: "Status";
  }
  .surveyGrid >>> table.el-table__body td:nth-of-type(6):before {
    content: "Action";
  }
}
</style>
